import { createTheme } from "@mui/material/styles";

// Create a custom theme
const theme = createTheme({
  typography: {
    fontFamily: '"Rethink Sans"', // Apply the fonts globally
  },
  // textfield: {
  //     fontFamily: '"Open Sans", sans-serif', // Apply the fonts globally
  // },

  // You can customize other MUI theme settings here
  components: {
    // MuiButton: {
    //     styleOverrides: {
    //         root: {
    //             fontFamily: '"Open Sans", sans-serif', // Override font for Button
    //         },
    //     },
    // },
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: '"Rethink Sans"', // Override font for Typography
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          fontFamily: '"Rethink Sans"', // Override font for Typography
        },
      },
    },
    MuiInput: {
      styleOverrides: {
        root: {
          fontFamily: '"Rethink Sans"', // Override font for Typography
        },
      },
    },
  },
});

export default theme;
